module.exports = __webpack_public_path__ + "static/martha-stories-kibble-4c6c0a6024a1a45d3250c94f9988d710.webm";